import React, { useEffect, useState } from "react";
import style from "./editMeasurement.module.scss";
import { Button, Form, TextField } from "../../../primary";
import { useDispatch, useSelector } from "react-redux";
import infoIcon from "../../../../static/images/info.svg";
import { calculateSurfaceArea, measurementNumber, prefixO } from "../../../../utils";
import { CANCEL_BTN, SAVE_BTN } from "../../../../constants";
import { useForm } from "react-hook-form";
import { ne1updateassessmentmeasurementAsync } from "../../../../app/patientSlice";
import { useParams } from "react-router-dom";
import Tooltip from "../../../secondary/Tooltip/tooltip";
import { PERMISSIONS } from "../../../../constants/permissions";

export const EditMeasurement = ({
  setFormChangesConfirm,
  handleEdit,
  fieldDefaults = {},
  showCancel = false,
  formChanges = false,
  buttonClass = "",
  setMeasurementForm,
  setMeasurementModal,
  editable,
  setEditable,
  setEditBtn,
}) => {
  const dispatch = useDispatch();
  const { register, handleSubmit, errors } = useForm();
  const { patientId } = useParams();
  const [systemMeasured, setSystemMeasured] = useState(false);
  const { measurementData } = useSelector((state) => state.patient.newWoundMeasurements) || { loading: false, measurementData: null };
  const assessmentDetail = useSelector((state) => state.patient.detailAssessment);

  useEffect(() => {
    if (measurementData) {
      setSystemMeasured(measurementData?.systemMeasured === 1 ? true : false);
    }
  }, [measurementData]);

  const getValue = (field) => measurementData?.[field] ?? "";

  const doSubmit = (data) => {
    let surFaceFinal = calculateSurfaceArea(data.length, data.width);
    const payload = Object.assign({}, assessmentDetail, {
      measurement: {
        assessedPicture: measurementData?.assessedImageSASURL || measurementData?.intialImageSASURL,
        isStickerAvailable: measurementData?.isStickerAvailable,
        stickerArea: measurementData?.stickerArea,
        stickerLength: measurementData?.stickerLength,
        surfaceArea: surFaceFinal,
        length: data?.length ? prefixO(data.length) : measurementData?.length ? measurementData?.length : 0,
        width: data?.width ? prefixO(data.width) : measurementData?.width ? measurementData?.width : 0,
        tunneling: prefixO(data?.tunneling),
        depth: prefixO(data?.depth),
        undermining: prefixO(data?.undermining),
        systemMeasured: systemMeasured ? 1 : 0,
        isMeasurementResolved: measurementData?.isMeasurementResolved,
      },
    });
    dispatch(ne1updateassessmentmeasurementAsync(patientId, payload));
    setMeasurementForm(false);
    setMeasurementModal(false);
    if (editable) {
      setEditable(false);
      setEditBtn(true);
    }
  };

  return (
    <Form setFormChangesConfirm={setFormChangesConfirm} formChanges={formChanges} onSubmit={handleSubmit(doSubmit)} requiredPermission={PERMISSIONS.MEASUREMENT_EDIT}>
      <div>
        <TextField
          classes={{
            column: `row mb-3 align-items-center`,
            labelClass: `col-5 ${style.label_spec_edit}`,
            inputColumn: "col-5 p-0",
            inputClassName: `${style.input_field}`,
          }}
          label={
            <div className={`d-inline-flex ${style.label_spec_edit}`}>
              Surface Area (cm
              {assessmentDetail?.isWoundWithoutPhoto === 0 && (
                <sup style={{ top: 0 }}>
                  <b>2</b>
                </sup>
              )}
              ):
              {assessmentDetail?.isWoundWithoutPhoto === 1 && (
                <Tooltip
                  placement="top"
                  className={style.tooltip_Edit}
                  content={
                    <>
                      Surface area is auto-calculated using length <b>x</b> width formula
                    </>
                  }
                >
                  <img src={infoIcon} alt="info" />
                </Tooltip>
              )}
            </div>
          }
          type="number"
          name="surfaceArea"
          defaultValue={getValue("surfaceArea")}
          validator={register(measurementNumber)}
          errors={errors}
          disabled={
            assessmentDetail?.isWoundWithoutPhoto === 0 && assessmentDetail?.woundStage === "resolve" && measurementData?.isMeasurementResolved === 1
              ? false
              : true
          }
        />

        {["length", "width", "depth", "undermining", "tunneling"].map((field) => (
          <TextField
            key={field}
            classes={{
              column: `row mb-3 align-items-center`,
              labelClass: `col-5 ${style.label_spec_edit}`,
              inputColumn: "col-5 p-0",
              inputClassName: `${style.input_field}`,
            }}
            label={field.charAt(0).toUpperCase() + field.slice(1) + " (cm):"}
            type="number"
            id={field}
            name={field}
            defaultValue={getValue(field)}
            validator={register(measurementNumber)}
            errors={errors}
            // disabled={isFieldDisabled(field)}
          />
        ))}
      </div>

      <div className="pt-4 pb-3 text-center">
        <Button classes={{ className: `btn ${buttonClass}` }} type="submit">
          {SAVE_BTN}
        </Button>
        {showCancel && (
          <Button type="button" classes={{ className: `btn ${style.cancel_btn}` }} onClick={() => handleEdit("nonEditable", "cancel")}>
            {CANCEL_BTN}
          </Button>
        )}
      </div>
    </Form>
  );
};
